import { Modal, Button } from 'react-bootstrap';
import { ILogisticsWithOption, ITransportType } from '@nkr/models/index';
import { TransportMethod } from '@nkr/enums/index';
import { TableHeadWrapper, TableBodyWrapper } from '@nkr/views/swap-management/styles';
import styled from 'styled-components';
import { TableWrapper } from '../../to-do/lists/styles';
import { optionColors } from '@nkr/views/swap-management/swaps/swap-list/logistics/option-content';
import { Fragment, useEffect, useState } from 'react';
import usePrevious from '@nkr/services/use-previous';
import { Utility } from '@nkr/services/utility';

const OptionRow = styled.tr`
    & > td > button {
        margin-top: 5px;;
    }
`;

interface IProps {
    show: boolean,
    data: ILogisticsWithOption,
    transportTypes: ITransportType[]
    onSave: (planId: number) => void,
    onCancel: () => void
}

const LogisticsOption = (props: IProps) => {
    const [selectedOption, setSelectedOption] = useState(-1);
    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show == true) {
            setSelectedOption(-1);
        }
    }, [props.show]);

    const handleSelectOption = (value: number) => {
        setSelectedOption(value);
    };

    const handleSave = () => {
        props.onSave(props.data.list[selectedOption].id);
    };

    const handleCancel = () => {
        props.onCancel();
    };

    if (props.data == null)
        return null;

    const viableOptions = props.data.list.filter(x => x.transportMethod > 0);
    const optionList = viableOptions.map((opt, index) => { return opt.optionNumber });
    const width = 80 / (optionList.length * 2);

    return (
        <div role="dialog">
            <div className="fade modal-backdrop in"></div>
            <div role="dialog" tabIndex={-1} className="fade in modal" style={{ display: 'block' }}>
                <div className="modal-dialog" style={{ width: optionList.length >= 3 ? '80%' : '55%' }}>
                    <div className="modal-content" role="document">
                        <Modal.Header>
                            <Modal.Title>Logistics Options for Swap {props.data.chainId}/{props.data.clusterNumber}/{props.data.position}</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <div className='alert alert-info text-center' style={{ padding: 7.5, marginBottom: 10 }}>An option must be selected by <strong>{props.data.deadline}</strong> or the first option will be selected automatically</div>
                            <TableWrapper className='table table-condensed'>
                                <TableHeadWrapper>
                                    <tr>
                                        <th style={{ width: '20%' }}></th>
                                        {optionList.map(option =>
                                            <th colSpan={2} key={option} className='text-center' style={{ backgroundColor: optionColors[option] }}>Option {option + 1}</th>
                                        )}
                                    </tr>
                                    <tr>
                                        <th></th>
                                        {optionList.map(option =>
                                            <Fragment key={option}>
                                                <th className='text-center' style={{ width: `${width}%`, backgroundColor: optionColors[option] }}>Primary</th>
                                                <th className='text-center' style={{ width: `${width}%`, backgroundColor: optionColors[option] }}>Backup</th>
                                            </Fragment>
                                        )}
                                    </tr>
                                </TableHeadWrapper>
                                <TableBodyWrapper>
                                    <tr>
                                        <td style={{ fontWeight: 700 }}>Kidney Pickup Date/Time</td>

                                        {optionList.map(option => {
                                            let isSelected = option == selectedOption;
                                            let backgroundColor = isSelected ? 'yellow' : 'white';
                                            let color = isSelected ? 'black' : 'initial';
                                            let showBackup = props.data.list[option].transportMethodBackup != null;

                                            return (
                                                <>
                                                    <td key={`kpdt${option}`} style={{ backgroundColor, color }}>
                                                        {props.data.list[option].kidneyPickupDateTime} {props.data.list[option].kidneyPickupDateTimeTz}
                                                    </td>
                                                    <td key={`kpdtb${option}`} style={{ backgroundColor, color }}>
                                                        {showBackup ? <>{props.data.list[option].kidneyPickupDateTimeBackup} {props.data.list[option].kidneyPickupDateTimeTz}</> : null}
                                                    </td>
                                                </>
                                            );
                                        })}
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: 700 }}>Flight Route or Ground</td>

                                        {optionList.map(option => {
                                            let isSelected = option == selectedOption;
                                            let backgroundColor = isSelected ? 'yellow' : 'white';
                                            let color = isSelected ? 'black' : 'initial';

                                            return (
                                                <>
                                                    <td key={`kpdt${option}`} style={{ backgroundColor, color }}>
                                                        {props.data.list[option].flightRouteOrGround}
                                                    </td>
                                                    <td key={`kpdtb${option}`} style={{ backgroundColor, color }}>
                                                        {props.data.list[option].flightRouteOrGroundBackup}
                                                    </td>
                                                </>
                                            );
                                        })}
                                    </tr>
                                    <tr>
                                        <td style={{ fontWeight: 700 }}>Transport Method</td>

                                        {optionList.map(option => {
                                            const transportType = props.transportTypes.find(tt => tt.id == props.data.list[option].transportMethod);
                                            const tt = transportType != null ? transportType.description : '';
                                            const transportTypeBackup = props.transportTypes.find(tt => tt.id == props.data.list[option].transportMethodBackup);
                                            const ttb = transportTypeBackup != null ? transportTypeBackup.description : '';

                                            let isSelected = option == selectedOption;
                                            let backgroundColor = isSelected ? 'yellow' : 'white';
                                            let color = isSelected ? 'black' : 'initial';

                                            return (
                                                <>
                                                    <td key={`kpdt${option}`} style={{ backgroundColor, color }}>
                                                        {tt}
                                                    </td>
                                                    <td key={`kpdtb${option}`} style={{ backgroundColor, color }}>
                                                        {ttb}
                                                    </td>
                                                </>
                                            );
                                        })}
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: 700 }}>Transportation Cost</td>

                                        {optionList.map(option => {
                                            let isSelected = option == selectedOption;
                                            let backgroundColor = isSelected ? 'yellow' : 'white';
                                            let color = isSelected ? 'black' : 'initial';
                                            let transportCost = props.data.list[option].totalCost;
                                            let transportCostBackup = props.data.list[option].totalCostBackup;
                                            let isCharter = props.data.list[option].transportMethod == TransportMethod.Charter
                                                || props.data.list[option].transportMethod == TransportMethod.CharterComm
                                                || props.data.list[option].transportMethod == TransportMethod.CommCharter;
                                            let isCharterBackup = props.data.list[option].transportMethodBackup == TransportMethod.Charter
                                                || props.data.list[option].transportMethodBackup == TransportMethod.CharterComm
                                                || props.data.list[option].transportMethodBackup == TransportMethod.CommCharter;
                                            let showBackup = props.data.list[option].transportMethodBackup != null;

                                            return (
                                                <>
                                                    <td key={`kpdt${option}`} style={{ backgroundColor, color }}>
                                                        {isCharter ?
                                                            transportCost > 0 ? Utility.formatUsDollar(Math.round(transportCost), 0) : ''
                                                            :
                                                            <a href='https://www.kidneyregistry.com/membership-terms-legacy' title='NKR Terms and Conditions' target='_blank'>T&amp;C</a>
                                                        }
                                                    </td>
                                                    <td key={`kpdtb${option}`} style={{ backgroundColor, color }}>
                                                        {showBackup && isCharterBackup ?
                                                            transportCostBackup > 0 ? Utility.formatUsDollar(Math.round(transportCost), 0) : ''
                                                            :
                                                            <>{showBackup ? <a href='https://www.kidneyregistry.com/membership-terms-legacy' title='NKR Terms and Conditions' target='_blank'>T&amp;C</a> : null}</>
                                                        }
                                                    </td>
                                                </>
                                            );
                                        })}
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: 700 }}>Flight Carrier &amp; Number</td>

                                        {optionList.map(option => {
                                            let isSelected = option == selectedOption;
                                            let backgroundColor = isSelected ? 'yellow' : 'white';
                                            let color = isSelected ? 'black' : 'initial';
                                            let showBackup = props.data.list[option].transportMethodBackup != null;

                                            return (
                                                <>
                                                    <td key={`kpdt${option}`} style={{ backgroundColor, color }}>
                                                        {props.data.list[option].flightCarrierAndNumber}
                                                    </td>
                                                    <td key={`kpdtb${option}`} style={{ backgroundColor, color }}>
                                                        {showBackup ? <>{props.data.list[option].flightCarrierAndNumberBackup}</> : null}
                                                    </td>
                                                </>
                                            );
                                        })}
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: 700 }}>Leg 1 Departure Date/Time</td>

                                        {optionList.map(option => {
                                            let isSelected = option == selectedOption;
                                            let backgroundColor = isSelected ? 'yellow' : 'white';
                                            let color = isSelected ? 'black' : 'initial';
                                            let showBackup = props.data.list[option].transportMethodBackup != null;

                                            return (
                                                <>
                                                    <td key={`kpdt${option}`} style={{ backgroundColor, color }}>
                                                        {props.data.list[option].flightDepartureTime} {props.data.list[option].flightDepartureTimeTz}
                                                    </td>
                                                    <td key={`kpdtb${option}`} style={{ backgroundColor, color }}>
                                                        {showBackup ? <>{props.data.list[option].flightDepartureTimeBackup} {props.data.list[option].flightDepartureTimeBackupTz}</> : null}
                                                    </td>
                                                </>
                                            );
                                        })}
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: 700 }}>Leg 1 Arrival Date/Time</td>

                                        {optionList.map(option => {
                                            let isSelected = option == selectedOption;
                                            let backgroundColor = isSelected ? 'yellow' : 'white';
                                            let color = isSelected ? 'black' : 'initial';
                                            let showBackup = props.data.list[option].transportMethodBackup != null;

                                            return (
                                                <>
                                                    <td key={`kpdt${option}`} style={{ backgroundColor, color }}>
                                                        {props.data.list[option].flightArrivalTime} {props.data.list[option].flightArrivalTimeTz}
                                                    </td>
                                                    <td key={`kpdtb${option}`} style={{ backgroundColor, color }}>
                                                        {showBackup ? <>{props.data.list[option].flightArrivalTimeBackup} {props.data.list[option].flightArrivalTimeBackupTz}</> : null}
                                                    </td>
                                                </>
                                            );
                                        })}
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: 700 }}>Leg 2 Departure Date/Time</td>

                                        {optionList.map(option => {
                                            let isSelected = option == selectedOption;
                                            let backgroundColor = isSelected ? 'yellow' : 'white';
                                            let color = isSelected ? 'black' : 'initial';
                                            let showBackup = props.data.list[option].transportMethodBackup != null;

                                            return (
                                                <>
                                                    <td key={`kpdt${option}`} style={{ backgroundColor, color }}>
                                                        {props.data.list[option].flightLeg2DepartureTime} {props.data.list[option].flightLeg2DepartureTimeTz}
                                                    </td>
                                                    <td key={`kpdtb${option}`} style={{ backgroundColor, color }}>
                                                        {showBackup ? <>{props.data.list[option].flightLeg2DepartureTimeBackup} {props.data.list[option].flightLeg2DepartureTimeBackupTz}</> : null}
                                                    </td>
                                                </>
                                            );
                                        })}
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: 700 }}>Leg 2 Arrival Date/Time</td>

                                        {optionList.map(option => {
                                            let isSelected = option == selectedOption;
                                            let backgroundColor = isSelected ? 'yellow' : 'white';
                                            let color = isSelected ? 'black' : 'initial';
                                            let showBackup = props.data.list[option].transportMethodBackup != null;

                                            return (
                                                <>
                                                    <td key={`kpdt${option}`} style={{ backgroundColor, color }}>
                                                        {props.data.list[option].flightLeg2ArrivalTime} {props.data.list[option].flightLeg2ArrivalTimeTz}
                                                    </td>
                                                    <td key={`kpdtb${option}`} style={{ backgroundColor, color }}>
                                                        {showBackup ? <>{props.data.list[option].flightLeg2ArrivalTimeBackup} {props.data.list[option].flightLeg2ArrivalTimeBackupTz}</> : null}
                                                    </td>
                                                </>
                                            );
                                        })}
                                    </tr>

                                    <tr>
                                        <td style={{ fontWeight: 700 }}>Kidney Arrival Date/Time</td>

                                        {optionList.map(option => {
                                            let isSelected = option == selectedOption;
                                            let backgroundColor = isSelected ? 'yellow' : 'white';
                                            let color = isSelected ? 'black' : 'initial';
                                            let showBackup = props.data.list[option].transportMethodBackup != null;

                                            return (
                                                <>
                                                    <td key={`kpdt${option}`} style={{ backgroundColor, color }}>
                                                        {props.data.list[option].kidneyArrivalDateTime} {props.data.list[option].kidneyArrivalDateTimeTz}
                                                    </td>
                                                    <td key={`kpdtb${option}`} style={{ backgroundColor, color }}>
                                                        {showBackup ? <>{props.data.list[option].kidneyArrivalDateTimeBackup} {props.data.list[option].kidneyArrivalDateTimeTz}</> : null}
                                                    </td>
                                                </>
                                            );
                                        })}
                                    </tr>

                                    <OptionRow>
                                        <td></td>

                                        {optionList.map(option =>
                                            <td colSpan={2} key={`remove${option}`} className='text-center'><Button bsStyle='primary' bsSize='small' onClick={() => handleSelectOption(option)}>Select Option</Button></td>
                                        )}
                                    </OptionRow>
                                </TableBodyWrapper>
                            </TableWrapper>
                        </Modal.Body>

                        <Modal.Footer>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>

                                </div>
                                <div>
                                    <Button bsStyle='primary' disabled={selectedOption < 0} onClick={handleSave}>Submit Selected Option</Button>
                                    <Button onClick={handleCancel}>Cancel</Button>
                                </div>
                            </div>
                        </Modal.Footer>
                    </div>
                </div>
            </div>
        </div>
    );

    // return (
    //     <div role="dialog">
    //         <div className="fade modal-backdrop in"></div>
    //         <div role="dialog" tabIndex={-1} className="fade in modal" style={{ display: 'block' }}>
    //             <div className="custom-modal modal-dialog">
    //                 <div className="modal-content" role="document">
    //                     <div className="modal-header">
    //                         <button type="button" className="close">
    //                             <span aria-hidden="true">×</span>
    //                             <span className="sr-only">Close</span>
    //                         </button>
    //                         <h4 className="modal-title">Logistics Options for Swap 4108/1/1</h4>
    //                     </div>
    //                     <div className="modal-body">test</div>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // )
}

export default LogisticsOption;